<template>
    <validation-observer ref="addActivityForm" v-slot="{ invalid }">
        <b-form @submit.prevent>
            <b-row>
                <b-col lg="6">
                    <b-form-group id="input-group-2" label="الفصل" label-for="input-2">
                        <validation-provider :name="$t('activities.semester')" vid="activity_semester" rules="required"
                            v-slot="{ errors }">
                            <v-select v-if="semesters.length" v-model="newItem.semesterCode" :options="semesters"
                                class="w-100" label="name" :state="errors.length > 0 ? false : null"
                                @input="getSubjectCodes()" />

                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                <b-col lg="6" v-if="newItem.semesterCode">
                    <b-form-group id="input-group-1" label="المادة" label-for="input-1">
                        <validation-provider :name="$t('activities.subject')" vid="activity_subject" rules="required"
                            v-slot="{ errors }">
                            <v-select v-model="newItem.subjectCode" :options="subjects" class="w-100" label="name"
                                :state="errors.length > 0 ? false : null" @input="getActivities()" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                <b-col lg="6" v-if="newItem.subjectCode && newItem.semesterCode">
                    <b-form-group id="input-group-3" :label="$t('activities.type')" label-for="input-3">
                        <validation-provider :name="$t('activities.type')" vid="activity_type" rules="required"
                            v-slot="{ errors }">
                            <v-select v-model="newItem.type" :options="types ? types : []" class="w-100"
                                :state="errors.length > 0 ? false : null" @input="getActivityCodes()" />

                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

            </b-row>
            <hr />
            <div v-if="newItem.type === 'واجب' || newItem.type == 'مشروع'">
                <ProjectAndAssignmentForm :newItem="newItem" :activitiesCodes="activitiesCodes" />
                <button class="btn btn-primary" v-b-modal="'payload'" @click="save(1)" type="button">حفظ</button>
            </div>
            <div v-else-if="newItem.type == 'منتدي'">
                <ForumForm :newItem="newItem" :activitiesCodes="activitiesCodes" />
                <button class="btn btn-primary" v-b-modal="'payload'" @click="save(2)" type="button">حفظ</button>
            </div>
            <div v-else-if="newItem.type == 'امتحان قصير'">
                <ShortExamForm :newItem="newItem" :activitiesCodes="activitiesCodes" />
                <button class="btn btn-primary" @click="save(3)" type="button">حفظ</button>
            </div>
        </b-form>

    </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";


import ProjectAndAssignment from "./activitiesForms/projectAndAssignment.vue";
import ForumForm from "./activitiesForms/forum.vue";
import ShortExamForm from "./activitiesForms/shortExam.vue";
import Swal from "sweetalert2";
import ActivitiesController from "@/Controllers/ActivitiesController";
import SemesterController from "@/Controllers/SemesterController";
import axios from "axios";
export default {
    props: ['newItem', 'getActivityCodes', 'getActivities', 'getSubjectCodes', 'types', 'activitiesCodes', 'subjects'],
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect,
        ProjectAndAssignmentForm: ProjectAndAssignment,
        ForumForm,
        ShortExamForm
    },
    data() {
        return {
            semesters: [],
            payload: null,
            activitiesController: new ActivitiesController(),
            controller: new SemesterController(),
        };
    },
    created() {
        // Subjects & Semesters
        this.controller.getSemesters().then((response) => {
            this.semesters = response;
            });
    },
    methods: {
        getBytes(size) {
            const fileSizes = {
                "5MB": 5242880,
                "2MB": 2097152,
                "1MB": 1048576,
                "500KB": 512000,
                "100KB": 102400,
                "50KB": 51200,
                "10KB": 10240
            };

            return fileSizes[size]
        },
        async uploadToServer(type, payload, edit = false) {
            
            if (type == 1) {
                let formData = new FormData();
                formData.append("SubjectCode", payload.subjectCode);
                formData.append("SemesterCode", payload.semesterCode);
                formData.append("AssessmentType", payload.code);
                formData.append("AvailableFrom", new Date(payload.from).toLocaleString("en-GB", { hour12: false }).replace(",", ""));
                formData.append("DueDate", new Date(payload.to).toLocaleString("en-GB", { hour12: false }).replace(",", ""));
                formData.append("CloNumber", payload.education_level == "CLO1" ? 1 : payload.education_level == "CLO2" ? 2 : 3);
                formData.append("Name", payload.name);
                formData.append("Description", payload.description);
                formData.append("AssignmentType", payload.homework_type == "نص مباشر" ? "Text" : "Files");
                formData.append("AllowResubmitting", payload.allow_resubmit);
                formData.append("PreventLateSubmissions", payload.disallow_delayed_homeworks);
                formData.append("MaximumSize", this.getBytes(payload.file_size));
                formData.append("MaximumUploadedFiles", payload.max_files_allowed_count);
                let res = null;
                if(edit){
                    formData.append("id", payload.id);
                    res = await this.activitiesController.editHomeWork(formData);
                }else{
                     res = await this.activitiesController.uploadHomeWork(formData);
                }
                return res.data;
            } else if (type == 2) {
                let fd = new FormData();
                fd.append("SubjectCode", payload.subjectCode);
                fd.append("SemesterCode", payload.semesterCode);
                fd.append("AssessmentType", payload.code);
                fd.append("AvailableFrom", new Date(payload.from).toLocaleString("en-GB", { hour12: false }).replace(",", ""));
                fd.append("DueDate", new Date(payload.to).toLocaleString("en-GB", { hour12: false }).replace(",", ""));
                fd.append("CloNumber", payload.education_level === "CLO1" ? 1 : payload.education_level === "CLO2" ? 2 : 3);
                fd.append("Name", payload.name);
                fd.append("MaximumSize", this.getBytes(payload.file_size));
                fd.append("MaximumUploadedFiles", payload.max_files_allowed_count);
                fd.append("AggregateType", payload.rate_type === "متوسط التقييمات" ? "Average" : "Maximum");

                // **Handling Nested Object (ForumDiscussion)**
                fd.append("ForumDiscussion[Subject]", payload.subject);
                fd.append("ForumDiscussion[Message]", payload.discussion);
                let res = null;
                if(edit){
                    fd.append("id", payload.id);
                    res = await this.activitiesController.editForum(fd);

                }else{
                     res = await this.activitiesController.uploadForum(fd);
                }

                return res.data;
            } else {
                let fd = new FormData();
                fd.append("SubjectCode", payload.subjectCode);
                fd.append("SemesterCode", payload.semesterCode);
                fd.append("AssessmentType", payload.code);
                fd.append("AvailableFrom", new Date(payload.from).toLocaleString("en-GB", { hour12: false }).replace(",", ""));
                fd.append("DueDate", new Date(payload.to).toLocaleString("en-GB", { hour12: false }).replace(",", ""));
                fd.append("CloNumber", payload.education_level === "CLO1" ? 1 : payload.education_level === "CLO2" ? 2 : 3);
                fd.append("QuizName", payload.name);
                fd.append("TimeLimitEnabled", payload.allow);
                fd.append("TimeLimit", payload.period);
                fd.append("TimeUnit",
                    payload.period_type === "ثواني" ? 1 :
                        payload.period_type === "دقائق" ? 60 :
                            payload.period_type === "ساعات" ? 3600 :
                                payload.period_type === "أيام" ? 86400 : null
                );
                fd.append("AttemptsAllowed", payload.attemps);
                fd.append("AggregateType", payload.rate_type === "متوسط التقييمات" ? "Average" : "Maximum");

                let questionsAdjusted = [];

                payload.questions.forEach((question) => {
                    // let info = question.info;

                    // let answers = [];
   
                    // if (question.type == 'متعدد الأختيارات و اجابات') {
                    //     for (let i = 0; i < info.answers.length; i++) {
                    //         const answer = info.answers[i];

                    //         answers.push({
                    //             AnswerText: answer,
                    //             Value: answer == info.correct_answer ? 1 : 0,
                    //             AnswerOrder: info.answers.indexOf(info.correct_answer) + 1
                    //         });
                    //     }
                    // }else{
                    //     answers.push({
                    //         AnswerText : question.info.answer,
                    //         Value : 1,
                    //         AnswerOrder : 1
                    //     })
                    // }
   
                    
                    let questionAdjusted = {
                        Mark: question.mark,
                        QuestionText: question.question,
                        QuestionType: question.type == 'توصيل الأجابة الصحيحة' ? 'Matching' :
                            question.type == 'صح و خطأ' ? 'TrueFalse' :
                                question.type == 'متعدد الأختيارات و اجابات' ? 'MultipleChoiceWithAnswers' :
                                    question.type == 'ملء الفراغ' ? 'FillIn' :
                                        question.type == 'مقالي طويل' ? 'EssayLong' :
                                            question.type == 'مقالي قصير' ? 'EssayShort' :
                                                question.type == 'مقالي مركب' ? 'EssayStructured' :
                                                    question.type == 'متعدد الأختيارات و اجابة' ? 'MultipleChoiceWithAnswer' : 
                                                     question.type == 'ترتيب الأجابات' ? 'OrderIdeas' : '',
                        Owner: question.owner,
                        Difficulty: question.difficulty == 'بسيط' ? 'Easy' :
                            question.difficulty == 'متوسط' ? 'Average' :
                                question.difficulty == 'صعب' ? 'Difficult' : ''
                        ,
                        LearningObjective: question.education_results,
                        MentalitySkill: question.cognitive_ability == 'حفظ' ? 'Memorization' :
                            question.cognitive_ability == 'تطبيق' ? 'Implementation' :
                                question.cognitive_ability == 'تحليل' ? 'Analyzing' :
                                    question.cognitive_ability == 'تركييم' ? 'Formulation' :
                                        question.cognitive_ability == 'تقوييم' ? 'Evaluation' :
                                            question.cognitive_ability == 'فهم استدلال' ? 'UnderstandingInference' :
                                                question.cognitive_ability == 'فهم تفسير' ? 'UnderstandingExplainary' :
                                                    question.cognitive_ability == 'فهم ترجمة' ? 'UnderstandingInterpretation' :
                                                        ''
                        ,
                        Answers: question.answers,
                        Id: question.Id

                    };                    
                    questionsAdjusted.push(questionAdjusted);
                });

                fd.append("QuizQuestions", JSON.stringify(questionsAdjusted));
                let res = null;
                if(edit){
                    fd.append("id", payload.id);
            
                    res = await this.activitiesController.editQuiz(fd);

                }else{
                     res = await this.activitiesController.uploadQuiz(fd);
                     

                }
                return res.data;

            }

        },
        async save(type) {
            this.adjustPayload(type);
            if (this.newItem.edit == 0) {
                let res = await this.uploadToServer(type, this.payload);
                if (res.original.success) {
                    this.addCorrespondingIdsToPayload(res);
                    let res2 = await this.activitiesController.addActivityNew(this.payload);
                    if (res2.status == 'success') {
                        this.resetForm()
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: this.$i18n.t("site.successfully"),
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                } else {
                    Swal.fire({
                        position: "top-end",
                        icon: "error",
                        title: this.$i18n.t("حدث خطأ ما"),
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }


            } else {
           
                this.payload.id = this.newItem.assignment_id || this.newItem.forum_id || this.newItem.short_exam_id;

  
                
                let res = await this.uploadToServer(type, this.payload, true);
                if (res.original.success) {
 
                    this.payload.id = this.newItem.id;
                    
                    let res2 = await this.activitiesController.editActivityNew(this.payload);
                    if (res2.status == 'success') {
                        this.resetForm()
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: this.$i18n.t("site.successfully"),
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                } else {
                    Swal.fire({
                        position: "top-end",
                        icon: "error",
                        title: this.$i18n.t("حدث خطأ ما"),
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }

             
            }
            this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();

        },
        adjustPayload(type) {

            if (type == 1) {
                this.payload = {
                    subjectCode: this.newItem.subjectCode,
                    semesterCode: this.newItem.semesterCode,
                    activity_type: this.newItem.type,
                    code: this.newItem.code,
                    name: this.newItem.homework_name,
                    education_level: this.newItem.education_level,
                    from: this.newItem.from,
                    to: this.newItem.to,
                    //
                    description: this.newItem.description,
                    homework_type: this.newItem.homework_type,
                    allow_resubmit: this.newItem.allow_resubmit ? true : false,
                    disallow_delayed_homeworks: this.newItem.disallow_delayed_homeworks ? true : false,
                    file_size: this.newItem.file_size,
                    max_files_allowed_count: this.newItem.max_files_allowed_count
                }
            } else if (type == 2) {
                this.payload = {
                    subjectCode: this.newItem.subjectCode,
                    semesterCode: this.newItem.semesterCode,
                    activity_type: this.newItem.type,
                    code: this.newItem.code,
                    name: this.newItem.forum_name,
                    education_level: this.newItem.education_level,
                    from: this.newItem.from,
                    to: this.newItem.to,
                    //
                    file_size: this.newItem.file_size,
                    max_files_allowed_count: this.newItem.max_files_allowed_count,
                    rate_type: this.newItem.rate_type,
                    subject: this.newItem.subject,
                    discussion: this.newItem.discussion
                }
            } else {
             
                this.payload = {
                    subjectCode: this.newItem.subjectCode,
                    semesterCode: this.newItem.semesterCode,
                    activity_type: this.newItem.type,
                    code: this.newItem.code,
                    name: this.newItem.short_exam_name,
                    education_level: this.newItem.education_level,
                    from: this.newItem.from,
                    to: this.newItem.to,
                    //
                    period: this.newItem.period,
                    period_type: this.newItem.period_type,
                    allow: this.newItem.allow ? true : false,
                    rate_type: this.newItem.rate_type,
                    attemps: this.newItem.attemps,
                    short_exam_id: this.newItem.short_exam_id,
                    questions: this.newItem.questions.map((question) => {
                        // let info = {};

                        // if (question.type === 'توصيل الأجابة الصحيحة') {
                        //     info = {
                        //         answers: question.type_1_answers
                        //     };
                        // } else if (question.type === 'صح و خطأ') {
                        //     info = {
                        //         answer: question.type_2_answer
                        //     };
                        // } else if (question.type === 'متعدد الأختيارات و اجابات') {
                        //     info = {
                        //         answers: question.type_3_answers,
                        //         correct_answer: question.correct_answer
                        //     };
                        // } else {
                        //     info = {
                        //         answer: question.correct_answer_text
                        //     };
                        // }

                        return {
                            owner: question.owner,
                            type: question.type,
                            education_results: question.education_results,
                            difficulty: question.difficulty,
                            cognitive_ability: question.cognitive_ability,
                            question: question.question,
                            mark: question.mark,
                            Id: question.question_id,
                            answers: this.adjustAnswers(question),
                            // info: info,
                        };
                    })
                }

            }
        },
        adjustAnswers(question){
   
           if(question.type == 'صح و خطأ'){
                return [{
                    AnswerText: question.type_2_answer,
                    Value: 1,
                }];
            }else if(question.type == 'متعدد الأختيارات و اجابات'){
                return question.type_3_answers.map((answer, index) => ({
                    AnswerText: answer.answer,
                    Value: question.correctAnswersIndexes.includes(index) ? 1 : 0,
                    Id: answer.answer_id
                }));
            }else if(question.type == 'ترتيب الأجابات'){                
                return question.type_4_answers.map((answer, index) => ({
                    AnswerText: answer.answer,
                    AnswerOrder: answer.order,
                    Value: 1,
                    Id: answer.answer_id
                })).filter(answer => answer.AnswerText.trim() !== '');
            }else if(question.type == 'متعدد الأختيارات و اجابة'){
                
                return question.type_1_answers.map((answer, index) => ({
                    AnswerText: answer.answer,
                    Value:  question.correctAnswerIndex == index ? 1 : 0,
                    Id: answer.answer_id
                }));
            }else{
                return [{
                    AnswerText: question.correct_answer_text,
                    Value: 1
                }];
            }
        },
        addCorrespondingIdsToPayload(res){
            if (this.newItem.type == 'واجب' || this.newItem.type == 'مشروع') {
                this.payload.assignment_id = res.original.data.assignment.id;
            } else if (this.newItem.type == 'منتدي') {
                this.payload.forum_id = res.original.data.forum.id;
            } else {
               this.payload.short_exam_id = res.original.data.quiz.id;
       
               this.payload.questions.forEach((question) => {
                    let correspondingQuestion = res.original.data.quiz.quizQuestions.find(q => q.questionText === question.question);
                    question.question_id = correspondingQuestion ? correspondingQuestion.id : null;
                    question.answers.forEach((answer) => {
                        let correspondingAnswer = correspondingQuestion.answers.find(a => a.answerText === answer.AnswerText);
                        answer.answer_id = correspondingAnswer ? correspondingAnswer.id : null;
                        answer.answer_order = correspondingAnswer ? correspondingAnswer.answerOrder : null;
                        answer.value = correspondingAnswer ? correspondingAnswer.value : null;

                    });
                });
               
               
            }
        },
        resetForm() {
            this.newItem = {
                subjectCode: "",
                semesterCode: "",
                type: "",
                code: "",
                homework: "",
                homework_name: "",
                forum_name: "",
                description: "",
                education_level: "",
                from: "",
                to: "",
                homework_type: "",
                rate_type: "",
                subject: "",
                discussion: "",
                short_exam_name: "",
                period: "",
                period_type: "",
                attemps: "",
                allow: true,
                questions: [],
            }
        }
    },
};
</script>
